import React from 'react'
import { IonButton, IonCol, IonFooter, IonGrid, IonIcon, IonRow, IonToolbar } from '@ionic/react'
import './ButtonGroupsWithHelperText.component.css'
import { cloudUpload } from 'ionicons/icons'
import { preSubmitChart } from '../../submitChart/store/submitChart.actions'
import { useDispatch, useSelector } from 'react-redux'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { getRulesSelector } from '../../rules/selectors'
import { IRootState } from '../../../store'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import useAreAllErrorsCleared from '../hooks/useAreAllErrorsCleared.hook'
import { useOfflineStatus } from '../../../utilities/isOnline.util'
import useCheckToDisableBasedOnCustomStateRules from '../hooks/useCheckToDisableBasedOnCustomStateRules.hook'
import { useTranslation } from 'react-i18next'
import { getSignersSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import LockUploadBtn from './LockUploadBtn.component'

const ButtonGroupsWithHelperText: React.FC = () => {
  const dispatch = useDispatch()
  const rulesState = useSelector(getRulesSelector)
  const { errors } = rulesState
  const submitChartState = useSelector((state: IRootState) => state.submitChart)
  const { inProgress, success } = submitChartState
  const history = useHistory()
  const { t } = useTranslation()
  const allErrorsCleared = useAreAllErrorsCleared()
  const isOfflineStatus = useOfflineStatus()
  const disableBasedOnCustomStateRules = useCheckToDisableBasedOnCustomStateRules()
  const containsRequiredError = Object.values(errors)
    .flat()
    .some((error) => error.priority === 0)
  const shouldDisableUploadButton =
    inProgress ||
    success ||
    Object.values(errors)
      .flat()
      .some((error) => error.priority === 0) ||
    isOfflineStatus
  const signerState = useSelector(getSignersSelector)
  const serviceId = useSelector(getServiceIdSelector)
  const { complexRulesCount } = signerState
  const hasComplexRules = complexRulesCount?.filter((item) => item?.serviceId === Number(serviceId))

  const doPreSubmitChart = () => {
    dispatch(preSubmitChart())
    history.push(TabConstants.SHARE_TAB)
  }

  const submitChart = () => {
    if (!allErrorsCleared) {
      const alertState = {
        header: 'Warning',
        message: t('completeChart.existingErrorsCouldCauseUploadFailure'),
        buttons: [{ text: 'Cancel' }, { text: 'Yes', handler: doPreSubmitChart }],
      }
      dispatch(showAlert(alertState))
      return false
    }
    doPreSubmitChart()
  }

  return (
    <IonFooter className='w-100-mw-inherit'>
      <IonToolbar className='p-1 w-100-mw-inherit'>
        {containsRequiredError && (
          <>
            <span className='asterisk-red'>*</span>
            <i>{t('completeChart.requiredErrorsForUploading')}</i>
          </>
        )}
        {!containsRequiredError && disableBasedOnCustomStateRules ? (
          <i>{t('completeChart.customStateNotSupportedText')}</i>
        ) : null}
        {hasComplexRules?.[0]?.ruleCount > 0 && !containsRequiredError && !disableBasedOnCustomStateRules ? (
          <i>{t('completeChart.pcrRequiresUploadForCompletion')}</i>
        ) : null}
        <IonGrid className='ion-no-padding mt-1'>
          <IonRow>
            <IonCol size='4' sizeMd='3'>
              <IonButton
                className='chart-upload-button'
                expand='full'
                color={'primary'}
                size='default'
                fill='outline'
                disabled={shouldDisableUploadButton}
                onClick={submitChart}>
                <IonIcon slot='start' size='default' icon={cloudUpload}></IonIcon>
                Upload
              </IonButton>
            </IonCol>
            <IonCol size='8' sizeMd='4'>
              <LockUploadBtn />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonToolbar>
    </IonFooter>
  )
}

export default ButtonGroupsWithHelperText
